import ActionType from './action-type'
import * as Actions from './actions'
import {type ThunkAction} from 'redux-thunk'
import {REST} from '../../../api'
import {type AppState} from '../../types/app-state'
import {Api} from '../../../api/Api'
import {type GuidType} from '../../../values/generic-type-defintions'

const WATCHED_INCIDENTS_URL = '/api/v1/incidentResponseWatch'

const setError = (error: string): Actions.SetError => ({
    type: ActionType.SET_ERROR,
    payload: error,
})

const setLoading = (): Actions.SetLoading => ({
    type: ActionType.SET_LOADING,
})

const setWatchedIncidents = (watchedIncidents: string[]): Actions.SetWatchedIncidents => ({
    type: ActionType.SET_WATCHED_INCIDENTS,
    payload: watchedIncidents,
})

export const fetchWatchedIncidents = (): ThunkAction<void, AppState, Api, Actions.Action> => {
    return (dispatch) => {
        dispatch(setLoading())
        REST.get(WATCHED_INCIDENTS_URL)
            .then((response) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(setWatchedIncidents(response.data))
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable, @typescript-eslint/no-unsafe-argument
            .catch((err) => dispatch(setError(err)))
    }
}

export const addIncidentToWatchList = (
    incidentId: GuidType,
): ThunkAction<void, AppState, Api, Actions.Action> => {
    return (dispatch) => {
        dispatch(setLoading())
        REST.post(`${WATCHED_INCIDENTS_URL}/${incidentId}`)
            .then(() => {
                dispatch(fetchWatchedIncidents())
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((err) => {
                dispatch(fetchWatchedIncidents())
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(setError(err))
            })
    }
}

export const deleteIncidentFromWatchList = (
    incidentId: GuidType,
): ThunkAction<void, AppState, Api, Actions.Action> => {
    return (dispatch) => {
        dispatch(setLoading())
        REST.delete(`${WATCHED_INCIDENTS_URL}/${incidentId}`)
            .then(() => {
                dispatch(fetchWatchedIncidents())
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((err) => {
                dispatch(fetchWatchedIncidents())
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(setError(err))
            })
    }
}
